import routes from './routes'
import store from './store'

export default {
    name: 'm-uiutils',
    store: store,
    routes: routes
}